import React, { FC, useState } from 'react';
import { AutoComplete } from 'src/features/risk-assessment/components/AutoCompleteInput';
import { AnswerData, Answer, Question } from 'src/store/types';

interface NumberFieldProps {
  onChange: (number: string) => void;
  value: string;
  updateAnswer: (answerData: AnswerData) => void;
  answer: Answer;
  suggestions?: string[];
  question: Question;
}

export const NumberField: FC<NumberFieldProps> = ({
  onChange,
  value,
  updateAnswer,
  answer,
  suggestions,
  question,
}) => {
  const [blurIgnoreUpdate, setBlurIgnoreUpdate] = useState(false);

  const disableSuggestions = !question || !question.isSmart;
  const options = disableSuggestions || !suggestions ? [] : suggestions;

  const triggerAnswerUpdate = (selectVal?: string) => {
    updateAnswer({
      value: selectVal || value,
      id: answer?.id,
      internalId: answer?.internalId,
    });
  };

  const onBlur = () => {
    if (blurIgnoreUpdate) {
      setBlurIgnoreUpdate(false);
      return;
    }

    setTimeout(() => triggerAnswerUpdate(), 100);
  };

  const onSelect = (value: string) => {
    triggerAnswerUpdate(value);
    setBlurIgnoreUpdate(true);
  };

  return (
    <AutoComplete
      onChange={onChange}
      optionData={options}
      value={value}
      placeholder="1, 2, 3…"
      onBlur={onBlur}
      onSelect={onSelect}
    />
  );
};
